"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyBuffs = void 0;
function applyBuffs(args) {
    const { creatorId, targetId, effects = [], onApplied } = args;
    if (effects.length === 0) {
        return [];
    }
    const buffSequences = args.sequence.pushSequence("parallel");
    const appliedEffects = [];
    const effectIds = effects.map((buff) => {
        return this.applyBuff({
            creatorId,
            targetId,
            ...buff,
            sequence: buffSequences,
            onApplied(sequence, args) {
                var _a;
                appliedEffects.push(args);
                (_a = buff.onApplied) === null || _a === void 0 ? void 0 : _a.call(buff, sequence, args);
            },
        });
    });
    if (appliedEffects.length > 0) {
        onApplied === null || onApplied === void 0 ? void 0 : onApplied(buffSequences, appliedEffects);
    }
    return effectIds;
}
exports.applyBuffs = applyBuffs;
